export const USER_DEFINITIONS_PASSWORD_SEND_MAIL= "/User/UserChangePasswordSendEmail"
export const USER_DEFINITIONS_BY_GUID = "/User/GetUser"
export const USER_DEFINITIONS_UPDATE_NEW_PASSWORD = "/User/UpdateUserNewPassword"
